export default __webpack_public_path__ + "static/media/chevronDown.53dcd2b3.svg";